import { AuthService } from '@/data/services/auth.service';
import { LocalStorageManager } from '@/data/utils/local-storage';
import container from '@/plugins/services';
import store from '@/store';
import axios, { AxiosError } from 'axios';

const TOKEN_COOKIE = process.env.VUE_APP_TOKEN_COOKIE as string;

const http = axios.create({});

http.interceptors.request.use((config) => {
	const token = LocalStorageManager.get(TOKEN_COOKIE);
	if (token) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}
	return config;
}, (error) => {
	return Promise.reject(error);
});

http.interceptors.response.use(config => {
	return config;
}, (error: AxiosError) => {
	const request = error.request as XMLHttpRequest;
	if (request && request.status === 401) {
		const authService: AuthService = container.get('AuthService');
		store.reset();
		authService.deleteCookies();
		window.requestAnimationFrame(() => {
			window.location.href = 'login';
		});
	} else {
		return Promise.reject(error);
	}
});

export default http;